"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var MuiImage = function MuiImage(_ref) {
  var hrefLink = _ref.hrefLink,
      imageStyle = _ref.imageStyle,
      image = _ref.image,
      rootClass = _ref.rootClass;

  var styles = _Storyblok.default.anchorOrginToObj(rootClass);

  var imageStyles = _Storyblok.default.anchorOrginToObj(imageStyle);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hrefLink && /*#__PURE__*/_react.default.createElement("a", {
    href: hrefLink,
    target: "_self"
  }, /*#__PURE__*/_react.default.createElement("picture", {
    style: styles
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    style: imageStyles,
    alt: image
  }))), !hrefLink && /*#__PURE__*/_react.default.createElement("picture", {
    style: styles
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    style: imageStyles,
    alt: image
  })));
};

var _default = MuiImage;
exports.default = _default;
MuiImage.propTypes = {
  /**
   * Url for image to be displayed.
   */
  image: _propTypes.default.string.isRequired,

  /**
   * Url for image to be displayed.
   */
  hrefLink: _propTypes.default.string,

  /**
   * Css Styles for the image.
   */
  imageStyle: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * Css Styles for the image.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string)
};
MuiImage.defaultProps = {
  imageStyle: [],
  rootClass: [],
  hrefLink: null
};